import React, { useEffect, useState } from "react";
import { IoIosHeart } from "react-icons/io";
import { FiFilter } from "react-icons/fi";
import { FaChevronDown, FaChevronUp, FaCamera } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import ImageCarousel from "./ImageCarousel";
import { useStateContext } from "../contexts/ContextProvider";
import { Link } from "react-router-dom";

const ItemsGrid = (props) => {
  const { roomsArray } = props;
  const {
    userLikesArray,
    setUserLikesArray,
    recentlyViewedRoomsArray,
    setRecentlyViewedRoomsArray,
  } = useStateContext();

  const [sortedData, setSortedData] = useState(roomsArray);
  const [showFilter, setShowFilter] = useState(false);
  const [priceSort, setPriceSort] = useState(false);
  const [likedSort, setLikedSort] = useState(false);
  const [imageSort, setImageSort] = useState(false);
  const [filter, setFilter] = useState({ liked: false, pictures: false });

  const location = useLocation();

  useEffect(() => {
    setSortedData(roomsArray);
  }, [roomsArray]);

  const updateLiked = (id) => {
    if (userLikesArray.find((x) => x === id)) {
      setUserLikesArray(
        userLikesArray.toSpliced(
          userLikesArray.findIndex((x) => x === id),
          1
        )
      );
    } else {
      setUserLikesArray((prevState) => [...prevState, id]);
    }
  };

  const sortByPrice = () => {
    if (priceSort) {
      setSortedData(sortedData.sort((a, b) => a.rent - b.rent));
    } else {
      setSortedData(sortedData.sort((a, b) => b.rent - a.rent));
    }
    setPriceSort(!priceSort);
  };

  const sortByLiked = () => {
    if (!likedSort) {
      setSortedData(
        sortedData.sort((a, b) =>
          userLikesArray.find((x) => x === a.id) ? -1 : 0
        )
      );
    }
    setLikedSort(!likedSort);
  };

  const sortByImages = () => {
    setImageSort(!imageSort);
  };

  const handleChange = (event) => {
    const { id, checked } = event.target;
    setFilter((prevState) => ({
      ...prevState,
      [id]: checked,
    }));
    if (id === "liked") sortByLiked();

    if (id === "pictures") sortByImages();
  };

  const addToRecentlyViewed = (room) => {
    const duplicate = recentlyViewedRoomsArray.find((x) => x.id === room.id);
    if (duplicate) {
      setRecentlyViewedRoomsArray(
        recentlyViewedRoomsArray.toSpliced(
          recentlyViewedRoomsArray.findIndex((x) => x.id === room.id),
          1
        )
      );
    }
    if (recentlyViewedRoomsArray.length < 6) {
      setRecentlyViewedRoomsArray((prevState) => [...prevState, room]);
    } else {
      setRecentlyViewedRoomsArray(recentlyViewedRoomsArray.toSpliced(0, 1));
    }
  };

  // console.log(recentlyViewedRoomsArray);

  return (
    <div className="grid justify-items-center w-full p-0 mt-0">
      {location.pathname !== "/dashboard" && (
        <div
          className="flex justify-around w-full text-snappily-orange text-xl items-center 
      border-gray-300 border-1 py-2 mt-0"
        >
          <div
            className="flex items-center mr-5 cursor-pointer"
            onClick={sortByPrice}
          >
            <div>By price:</div>
            {priceSort ? <FaChevronUp /> : <FaChevronDown />}
          </div>
          <div
            className="flex items-center cursor-pointer relative"
            onMouseEnter={() => {
              setShowFilter(!showFilter);
            }}
            onMouseLeave={() => {
              setShowFilter(!showFilter);
            }}
          >
            <FiFilter />
            {showFilter && (
              <div
                className="absolute top-5 -right-12 h-40 w-48 bg-white text-black border-black border-2 
            rounded-2xl drop-shadow-3xl z-30"
              >
                <div className="flex justify-center text-xl py-2">
                  Filter By:
                </div>
                <div
                // onClick={(e) => e.stopPropagation()}
                >
                  <div className="flex justify-between px-5">
                    <div className="pr-3">Liked:</div>
                    <input
                      id="liked"
                      type="checkbox"
                      checked={filter.liked}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="flex justify-between px-5">
                    <div className="pr-3">Has Picture:</div>
                    <input
                      id="pictures"
                      type="checkbox"
                      checked={filter.pictures}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      <div className="w-full grid justify-items-center h-screen overflow-hidden overflow-y-auto pb-40">
        <ul
          className="w-full grid justify-items-center md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 
          gap-y-4 gap-x-1 p-5 pb-40"
        >
          {sortedData.map((item, index) => {
            return imageSort && item.images.length === 0 ? (
              ""
            ) : (
              <li key={item.id}>
                <div className="grid justify-items-center w-80 bg-white rounded-3xl drop-shadow-2xl">
                  <div className="grid relative items-center">
                    {item.images.length > 0 && (
                      <div
                        className="absolute top-2.5 left-3 flex items-center text-white bg-black 
                      opacity-40 px-1.5 z-10"
                      >
                        <FaCamera className="" />
                        <div className="ml-1 mt-0.5">{item.images.length}</div>
                      </div>
                    )}
                    <IoIosHeart
                      className={`absolute top-3 right-3 text-2xl z-10
                        ${
                          userLikesArray.find((x) => x === item.id)
                            ? "text-red-500"
                            : "text-slate-200 hover:text-red-300"
                        }`}
                      onClick={() => {
                        updateLiked(item.id);
                      }}
                    />
                    <ImageCarousel
                      roomUuid={item.roomUuid}
                      images={item.images}
                      customFunc={() => {
                        addToRecentlyViewed(item);
                      }}
                      type="rooms"
                    />
                  </div>
                  <div className="flex justify-around w-full">
                    <div className="flex justify-between w-full m-2 capitalize">
                      <div className="text-xl text-green-500">${item.rent}</div>
                      <div>
                        {item.propertyCity}, {item.propertyState}
                      </div>
                    </div>
                  </div>
                  <Link to={`/rooms/${item.roomUuid}`}>
                    <div
                      className="w-full h-20 text-black hover:text-blue-500 text-xl px-3 
                  pb-2 text-justifed cursor-pointer capitalize"
                      onClick={() => {
                        // navigate(`/rooms/${item.roomUuid}`);
                        addToRecentlyViewed(item);
                      }}
                    >
                      {item.shortDesc.length > 53
                        ? item.shortDesc.slice(0, 53).trim().toLowerCase() +
                          "..."
                        : item.shortDesc.toLowerCase()}
                    </div>
                  </Link>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ItemsGrid;
